<template>
  <div class="orders-page">
    <h1>我的訂單</h1>

    <!-- (1) Loading 狀態 -->
    <div class="loading" v-if="isLoading">
      <p>載入中...</p>
    </div>

    <!-- (2) 若已成功取得訂單 -->
    <div v-else>
      <!-- 若無訂單 -->
      <div v-if="pagedOrders.length === 0">
        <p class="no-orders">目前沒有任何訂單。</p>
      </div>

      <!-- 否則列出訂單清單 (卡片式) -->
      <div class="order-list">
        <div v-for="order in pagedOrders" :key="order.order_id" class="order-card">
          <!-- 訂單卡片 Header -->
          <div class="order-card-header">
            <div class="order-id-and-date">
              <p class="order-id">訂單編號：{{ order.order_id }}</p>
              <p class="order-date">下單時間：{{ order.created_at }}</p>
            </div>
            <div class="order-amount">
              <p class="total-amount">金額：<span class="highlight-amt" >NT$ {{ order.total_amount }}</span></p>
              <p v-if="Number(order.shipping_fee) > 0" class="shipping-fee">
                運費：NT$ {{ order.shipping_fee }}
              </p>
            </div>
          </div>

          <!-- 狀態與取消訂單 -->
          <div class="order-card-status-row">
            <b class="order-status">
              狀態：
              <span class="status-text" :style="{ color: order.status_color }">
                {{ order.status_label }}
              </span>
            </b>
            <button
            v-if="order.status_name === 'pending' && order.payment_status !== 1"
            class="btn-cancel-order"
            @click="cancelOrder(order.order_id)"
          >
            取消訂單
          </button>

          </div>

          <!-- 「展開明細」按鈕 -->
          <div class="toggle-details-row">
            <button class="btn-toggle-details" @click="toggleDetails(order.order_id)">
              {{ openedOrderId === order.order_id ? '隱藏明細' : '展開明細' }}
            </button>
          </div>

          <!-- 訂單明細 (若 openedOrderId === 該訂單) -->
          <transition name="fade">
            <div v-if="openedOrderId === order.order_id" class="order-details">
              <!-- {{ order}} -->
              <p>訂購人：{{ order.buy_name }} / {{ order.buy_phone }}</p>
              <p>收件人：{{ order.name }} / {{ order.phone }}</p>
              <p>收件地址：<span>
                {{ order.zip ? `(${order.zip})` : "" }}
                {{ order.city ? `${order.city}` : "" }}
                {{ order.district ? `${order.district}` : "" }}
                {{ order.street ? `${order.street}` : "" }}
                {{ order.store_id ? `(${order.store_id})` : "" }}
              {{ order.store_name ? `[${order.store_name}]` : "" }}
              {{ order.store_addr ? `${order.store_addr}` : "" }}
              </span>
              </p>
            
              <p>運送方式：
                <img v-if="order.shipping_icon_url" :src="order.shipping_icon_url" width="20" height="20" />
                {{ order.shipping }}
              </p>
              <p>付款方式：{{ order.payment_label }}</p>
              <p>
                  付款狀態：<span :style="{ color: order.payment_status_color }">{{ order.payment_status_label }}</span>
              </p>
              <p v-if="order.payment_status == 0 && order.payment_code">
                <span v-if="order.payment == 'atm'">虛擬帳號：<b :style="{ color: order.payment_status_color }">{{order.payment_code}}</b></span>
                <span v-if="order.payment == 'cvs'">超商代碼：<b :style="{ color: order.payment_status_color }">{{order.payment_code}}</b></span>
              </p>
              <p><span v-if="order.invoice_type === 'personal'">個人發票：<span v-if="order.carrier_type === '3J0002'">手機條碼
                    {{ order.mobile_barcode }}</span>
                  <span v-else-if="order.carrier_type === 'CQ0001'">自然人憑證 {{ order.citizen_barcode }}</span>
                  <span v-else-if="order.carrier_type === 'amego'">會員載具 {{ order.buy_email }}</span>
                </span>
                <span v-else-if="order.invoice_type === 'Company'">公司發票：{{ order.company_name }} - {{ order.tax_id
                  }}</span>
                <span v-else-if="order.invoice_type === 'Donate'">發票捐贈</span>
              </p>
              <p v-if="order.invoice_no">發票號碼：{{ order.invoice_no }}</p>
              <!-- ★這裡改成使用 orderItems[order.order_id] ★ -->
              <div v-if="orderItems[order.order_id]" class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>商品名稱</th>
                      <th>規格</th>
                      <th>數量</th>
                      <th>單價</th>
                      <th>小計</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in orderItems[order.order_id]" :key="item.order_detail_id">
                      <td data-label="名稱：">
                        <img 
                            v-if="item.image_url" 
                            :src="item.image_url" 
                            class="product-img"
                        />
                        {{ item.title }}
                      </td>
                      <td data-label="規格：">{{ item.variant_name || '無規格' }}</td>
                      <td data-label="數量：">{{ item.quantity }}</td>
                      <td data-label="單價：">NT$ {{ item.price }}</td>
                      <td data-label="小計：">NT$ {{ item.price * item.quantity }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-else class="loading-details">
                <p>載入明細中...</p>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <!-- 如果還有更多訂單 => Load More -->
      <div v-if="hasMore" class="load-more-row">
        <button 
          class="btn-load-more" 
          @click="loadMore" 
          :disabled="isLoadingMore"
        >
          <span v-if="!isLoadingMore">載入更多訂單</span>
          <span v-else>載入中...</span>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'   // ★ 引入 SweetAlert2

export default {
  name: 'OrdersPage',
  data() {
    return {
      isLoading: false,
      isInitialLoading: false,
      isLoadingMore: false,
      allOrders: [],  // 存已載入的訂單列表 (order_id, total_amount, ...)
      orderItems: {}, // ★用來存「order_id => 該訂單的明細array」
      total: 0,
      currentPage: 1,
      limit: 5,
      openedOrderId: null,
    };
  },
  computed: {
    // RWD：是否為手機
    isMobile() {
      return window.innerWidth <= 768;
    },
    // 動態分頁
    pagedOrders() {
      return this.allOrders; // 這裡如果你沒特別 slice，就直接回傳整個 allOrders
    },
    hasMore() {
      return this.allOrders.length < this.total;
    }
  },
  created() {
    if (
      this.$store.state.isLoggedIn &&
      this.$store.state.userProfile
    ) {
      this.fetchOrdersInitial();
    }else{
      this.$router.push('/login');
    }
  },
  methods: {
    async fetchOrdersInitial() { //初始載入
      try {

        this.isInitialLoading = true;
        const user_id = this.$store.state.userProfile.user_id;
        const res = await axios.get('/api/order/getUserOrdersByPage', {
          params: {
            user_id,
            page: this.currentPage,
            limit: this.limit,
          }
        });
        if (res.data.success) {
          this.allOrders = this.allOrders.concat(res.data.orders);
          this.total = res.data.total;
        } else {
          console.error(res.data.message);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isInitialLoading = false;
      }
    },
    async loadMore() { //載入更多
      try {
        this.isLoadingMore = true;
        this.currentPage++;
        const res = await axios.get('/api/order/getUserOrdersByPage', { 
          params: {
            user_id: this.$store.state.userProfile.user_id,
            page: this.currentPage,
            limit: this.limit,
          }
        });
        if (res.data.success) {
          this.allOrders = this.allOrders.concat(res.data.orders);
          this.total = res.data.total;
        }
      } catch(err) {
        console.error(err);
      } finally {
        this.isLoadingMore = false;
      }
    },
    toggleDetails(orderId) {
      if (this.openedOrderId === orderId) {
        this.openedOrderId = null;
      } else {
        this.openedOrderId = orderId;
        // 若 orderItems[orderId] 還沒載入 => 去撈
        if (!this.orderItems[orderId]) {
          this.loadOrderDetails(orderId);
        }
      }
    },
    async loadOrderDetails(orderId) {
      try {
        const res = await axios.get(`/api/order/getOrderDetails/${orderId}`);
        if (res.data.success) {
          // Vue 3: 直接賦值
          this.orderItems[orderId] = res.data.orderItems || []

          console.log( this.orderItems[orderId]);

        } else {
          console.error(res.data.message);
        }
      } catch (err) {
        console.error(err);
      }
    },
    async cancelOrder(orderId) {
      //if (!confirm(`確定要取消訂單 #${orderId} 嗎？`)) return;
      const result = await Swal.fire({
        title: `確定要取消訂單 #${orderId} 嗎？`,
        text: "訂單取消後將無法恢復！",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ff4400",
        cancelButtonColor: "#999",
        confirmButtonText: "確定取消",
        cancelButtonText: "返回"
      });
      if (result.isConfirmed) {
        try {
          const res = await axios.post(`/api/order/cancelOrder`, { order_id: orderId });
          console.log(res.data);
          if (res.data.success) {
            const found = this.allOrders.find(o => o.order_id === orderId);
            if (found) {
              found.status_name = res.data.status_name; //已取消
              found.status_label = res.data.status_label; // 更新狀態標籤
              found.status_color = res.data.status_color; // 更新狀態顏色
            }
            // 顯示成功
            Swal.fire({
              title: "訂單已取消！",
              icon: "success",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "關閉"
            });
          } else {
            // 顯示失敗
            Swal.fire("錯誤", res.data.message || "取消訂單失敗", "error");
          }
        } catch (err) {
          if (err.response && err.response.data) {
            if(err.response.data.payment_status == 1){
              const found = this.allOrders.find(o => o.order_id === orderId);
              console.log(found);
              found.payment_status = err.response.data.payment_status; //已付款
              found.payment_status_color = err.response.data.payment_status_color; // 更新付款狀態顏色
              found.payment_status_label = err.response.data.payment_status_label; // 更新付款狀態標籤

              return Swal.fire("錯誤", "付款已完成，無法取消訂單", "error");
            }
            if (err.response.data.status_name) {
              const found = this.allOrders.find(o => o.order_id === orderId);
              if (found) {
                found.status_name = err.response.data.status_name;
                found.status_label =  err.response.data.status_label; // 更新狀態標籤
                found.status_color =  err.response.data.status_color; // 更新狀態顏色
              }
            }
            console.error(err.response.data.message);
            return Swal.fire("錯誤", err.response.data.message || "取消訂單失敗", "error");

          } else {
            console.error(err);
            return Swal.fire("錯誤", "取消訂單失敗", "error");
          }
        }
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  table {
    width: 100%;
    border-collapse: collapse;
    /* 若有必要，可再加 "table-layout: fixed;" + "word-wrap: break-word;" */
  }

  th,
  td {
    /* 避免過長文字 */
    word-wrap: break-word;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
    /* 避免文字環繞導致超寬 */
  }

  .table-responsive {
    overflow-x: auto;
    /* 只允許表格自己可以左右捲動 */
    -webkit-overflow-scrolling: touch;
    /* iOS慣性 */
  }
}

.orders-page {
  /* 保持 desk */
  min-width: 800px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
}

@media (max-width: 768px) {
  .orders-page {
    min-width: 100%;
    padding: 8px;
    /* 更小 */
    box-sizing: border-box;
    /* 避免padding影響總寬度 */
  }
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

/* Loading */
.loading {
  text-align: center;
  font-size: 1.2rem;
  color: #666;
}

/* 無訂單 */
.no-orders {
  margin-top: 40px;
  text-align: center;
  font-size: 1.1rem;
  color: #333;
}

/* ====== 訂單列表 (卡片式) ====== */
.order-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.order-card {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  /* 原本的陰影拿掉，改用橘色 */
  box-shadow: 0 0 8px rgba(255, 140, 0, 0.5);
  /* 橘色陰影 */
  transition: box-shadow 0.2s;
}

.order-card:hover {
  /* 讓 hover 時的陰影更明顯或更大一些 */
  box-shadow: 0 0 12px rgba(255, 140, 0, 0.8);
}

/* 卡片 - Header */
.order-card-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.order-id-and-date {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-id {
  font-weight: bold;
  font-size: 1.2rem; /* 調整字體大小 */
}

.order-date {
  font-size: 1rem; /* 調整字體大小 */
  color: #666;
}

.order-amount {
  text-align: right;
  font-size: 1.2rem; /* 調整字體大小 */
}

.order-amount .total-amount {
  font-size: 1.3rem; /* 調整字體大小 */
  font-weight: bold;
  color: #333;
}

  
  /* 金額加粗 */
  .highlight-amt {
    color: #d9534f;
    font-weight: bold;
    font-size: 1.3rem;
  }

.order-amount .shipping-fee {
  font-size: 1rem; /* 調整字體大小 */
  color: #888;
}

/* 狀態 + 取消按鈕 row */
.order-card-status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.order-status {
  font-size: 1.1rem; /* 調整字體大小 */
  font-weight: 500;
}

.status-text {
  color: #ff6600;
  margin-left: 4px;
}

.btn-cancel-order {
  background: #ff4400;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem; /* 調整字體大小 */
}

.btn-cancel-order:hover {
  background: #dd2200;
}

/* 展開明細按鈕 */
.toggle-details-row {
  text-align: right;
  margin-bottom: 8px;
}

.btn-toggle-details {
  background: #f0f0f0;
  border: 1px solid #ccc;
  font-size: 1rem; /* 調整字體大小 */
  color: #333;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-toggle-details:hover {
  background: #e0e0e0;
}

/* 訂單明細區 */
.order-details {
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 12px;
  margin-top: 8px;
}

.order-details p {
  font-size: 1rem; /* 調整字體大小 */
  margin: 2px 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background: #f5f5f5;
}

/* 手機 (768px 以下) 時 → 改為 block 呈現 */
@media (max-width: 768px) {

  /* 1) 全部元素都變為 block，表頭隱藏 */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  thead {
    display: none;
    /* 隱藏表頭 */
  }

  /* 2) 每個 <tr> 當作「卡片」 */
  tr {
    margin-bottom: 12px;
    /* 行與行之間留白 */
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 8px;
    /* 這樣每一 row 像卡片 */
  }

  /* 3) 每個 <td> 改成左右排列 */
  td {
    display: flex;
    justify-content: flex-start;
    /* 全部靠左 */
    align-items: center;
    gap: 8px;
    /* 讓「欄位名稱」和「欄位內容」之間保留距離 */
    padding: 6px 0;
    border: none;
    /* 也可以保留 border-bottom 來做分隔 */
    text-align: left !important;
    /* 強制靠左 */
  }

  /* 4) 用 ::before 顯示 data-label（原本表格的欄位名稱） */
  td::before {
    /* 在 <td data-label="商品名稱"> 讀取 data-label */
    content: attr(data-label);
    font-weight: bold;
    margin-right: 8px;
    color: #666;
    flex: none;
    /* 不要讓欄位名自動撐開 */
  }
}

.loading-details {
  font-size: 0.9rem;
  color: #999;
  margin-top: 8px;
}

/* 載入更多 */
.load-more-row {
  text-align: center;
  margin-top: 20px;
}

.btn-load-more {
  background: #4a90e2;
  color: #fff;
  border: none;
  font-size: 1rem;
  padding: 10px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-load-more:hover {
  background: #357ab7;
}

/* 動畫 (顯示 / 隱藏明細) */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.product-img {
  width: 40px;
  height: auto; /* 讓高度自動等比縮放 */
  margin-right: 8px; /* 圖片與文字保留間距 */
  object-fit: cover; /* 若您想裁切圖片 */
}


/* 手機 RWD 調整 */
@media (max-width: 768px) {

  /* 每次載入 5 筆 */
  .orders-page {
    padding: 8px;
  }

  .order-card {
    padding: 12px;
    border-radius: 6px;
  }

  .order-card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .toggle-details-row {
    margin-top: 6px;
  }

  table {
    font-size: 0.85rem;
  }
}
</style>